import * as React from "react";
import {
  Flex,
  Text,
  Card,
  Form,
  FormSlider,
  Avatar,
} from "@fluentui/react-northstar";
import _ from "lodash";
import { Year } from "../common/utils";

export default function Slider(props) {
  const {
    image,
    max,
    defaultValue,
    customText,
    custom,
    title,
    discretionaryText,
  } = props;
  return (
    <>
      {defaultValue && max && (
        <Card.Column className="promoFooter">
          {image && (
            <Flex space="between" vAlign="center" className="sliderAvatar">
              <Avatar image={image} />
            </Flex>
          )}
          <Form>
            <FormSlider
              label={title ? title : "Glider"}
              fluid
              id="glider"
              min="0"
              max={max}
              value={defaultValue}
              className="biw_slider"
            />
          </Form>
          <Flex space="between" vAlign="center" className="sliderValue">
            <Text
              className="bit_text_12"
              content={custom ? customText : `${defaultValue}/${max}`}
            />
            {_.size(discretionaryText) > 0 && (
              <Flex gap="gap.smaller">
                <Text
                  className="bit_text_12 label_gray"
                  content={`${discretionaryText}`}
                />
              </Flex>
            )}
          </Flex>
        </Card.Column>
      )}
    </>
  );
}
